var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"vp",staticClass:"full-width",attrs:{"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }